import { GridColumnMenu, GridColumnMenuProps } from '@mui/x-data-grid-premium';

const IncDataGridColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuSortItem: null,
        columnMenuFilterItem: null,
        columnMenuAggregationItem: null,
        columnMenuGroupingItem: null,
        columnMenuPinningItem: null,
      }}
    />
  );
};

export default IncDataGridColumnMenu;
